import React from 'react';
import { KatIcon, KatPopover } from '@amzn/katal-react';
import { Pages, MetricKeys } from 'src/constants/metrics';
import clickMetric from 'src/utils/clickRateMetricsPublisher';
import { THREAD_LISTING } from 'src/constants/pages';
import { useTranslation } from 'src/utils';
import Link from 'next/link';
import { categoryToIconMap } from './CategoryCard';

export interface CategoryCardLegacyProps {
  categoryId: string;
  nameStringId: string;
}

const CategoryCardLegacy: React.FC<CategoryCardLegacyProps> = ({
  nameStringId,
  categoryId,
}) => {
  const { t } = useTranslation();
  const iconName = categoryToIconMap[nameStringId];

  return (
    <div data-testid="category-card" className="h-[38px] border border-solid border-kat-zircon bg-kat-white hover:border-kat-jungle-mist">
      <Link
        href={{ pathname: THREAD_LISTING, query: { 'categories[]': categoryId } }}
        data-testid="category-card-link"
        className="w-fit font-medium no-underline"
        onClick={() => clickMetric(Pages.home, MetricKeys.categoryCard, categoryId)}
      >
        <div className="flex h-full flex-col justify-between px-4 py-2.5">
          <div className="flex flex-row items-center gap-x-2">
            {
              iconName && (
                <KatIcon
                  className="mt-0.5 text-kat-nordic"
                  name={iconName}
                  size="tiny"
                />
              )
            }
            <KatPopover
              kat-aria-behavior="tooltip"
              position="top"
              triggerType="hover"
              variant="tooltip"
            >
              <h3
                slot="trigger"
                className="my-0 text-[13px] font-bold leading-[18px] text-kat-nordic hover:underline"
              >
                {t(nameStringId)}
              </h3>
              <div className="font-normal">{t(`${nameStringId}_desc`)}</div>
            </KatPopover>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CategoryCardLegacy;
